import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-add-exercise-support-article',
    template: `
        <ng-container i18n="@@support.articles.addExercise">
            <ol>
                <li>
                    <span>Go to <a routerLink="/organization/exercises">My exercises</a>.</span>
                </li>
                <li>
                    <span>Click the <strong>Create an exercise</strong> button.</span>
                </li>
                <li>
                    <div>
                        <p>Fill in the form.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/addExercise.png" />
                        </p>
                        <ul>
                            <li><strong>Name:</strong> give as clear a name as possible, so that you can easily find the exercise again. Students can see this name.</li>
                            <li><strong>Course:</strong> in which course do you want to insert the exercise. The default course of your organization is automatically filled in here.</li>
                            <li><strong>Chapter:</strong> choose the chapter where you want to add the exercise. An "Extra Exercises" lesson will appear at the end of this chapter.</li>
                            <li><strong>Exercise type:</strong> click on the type of exercise you want to do.</li>
                            <li><strong>Exercise:</strong> insert the exercise text here. Not sure how to enter the exercise text? Click the <em>"How to compose this type of exercise?"</em> button above the input field. Depending on the chosen exercise type, you will see an adapted explanation.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <div>
                        <h2>Optional: passing criteria</h2>
                        <p>If desired, you can set how many mistakes students are allowed to make, and at what speed they must type in order to achieve three stars on the exercise in the <strong>Passing criteria</strong> tab.</p>
                        <p>When creating a test for your students, it can be useful to limit the <strong>number of attempts</strong>. To do so, tick the box and enter the desired number of attempts.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/addExercisePassingCriteria.png" />
                        </p>
                    </div>
                </li>
                <li>
                    <div>
                        <h2>Optional: Set up student access</h2>
                        <p>If desired, you can set how students can access this exercise in the <strong>Who will have access to this exercise?</strong> tab.</p>
                        <p>
                            <a
                                routerLink="/support/organizations/exercises/access"
                                mat-stroked-button
                                color="primary"
                                class="supportLink"
                            >Student access to exercises</a>
                        </p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/addExerciseAccess.png" />
                        </p>
                    </div>
                </li>
                <li>
                    <span>Click <strong>Save</strong>.</span>
                </li>
                <li>
                    <div>
                        <p>Students will now see an <strong>Extra exercises</strong> lesson appear at the bottom of the chosen chapter. All extra exercises of that chapter are bundled in it.</p>
                        <p>This button is only visible when additional exercises are currently available in the chapter.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/extraExercises.png" />
                        </p>
                    </div>
                </li>
            </ol>
        </ng-container>
    `
})
export class AddExerciseSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
